import { createFileRoute, redirect } from '@tanstack/react-router';

// Bare /brand/$slug/settings → first rail item. After the d9d347f4 rail
// split the first item is communication, not notifications.
// (Renamed from "channels" to disambiguate from the publishing /channels
// surface that owns instagram/linkedin/tiktok/youtube.)
export const Route = createFileRoute('/brand/$slug/settings/')({
  // `search` is carried through. Dropping it silently ate every
  // `?slack=<flag>` the oauth callback sent here, so the founder's
  // connect result never reached the pill that exists to show it. The
  // callback now targets the communication route directly, but this stays
  // fixed too: patching only the caller leaves the same trap armed for
  // whatever links here next.
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/brand/$slug/settings/communication',
      params: { slug: params.slug },
      search,
    });
  },
});
